
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import Text from '../../common/client/components/Text';

import OverviewTitle from './OverviewTitle';

const classNames = mergeStyleSets({
    root: {
        border: '1px solid #dddddd',
        padding: 16,
        width: 500
    }
});

const OverviewPanel = (props) => {

    return (
        <div className={classNames.root}>
            <OverviewTitle title={props.title} />
            {(props.loaded)
                ? props.children
                : <Text>Načítám data...</Text>
            }
        </div>
    );
}

export default OverviewPanel;
